export default __webpack_public_path__ + "assets/Error-UnauthorizedAccess-Blue-391cfda.png";